var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTensorFlowIcon = function SvgTensorFlowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E55B2D",
    d: "M12.095 3.615v3.282l5.714 3.283V6.897zM.667 6.897v3.283l2.857 1.64V8.54zm8.57 1.642-2.856 1.64v9.847l2.857 1.64v-6.563l2.857 1.64v-3.281L9.238 11.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED8E24",
    d: "M12.095 3.615 3.524 8.54v3.281L9.238 8.54v3.281l2.857-1.64zm8.572 1.641-2.858 1.641v3.283l2.858-1.641zm-5.715 6.564-2.857 1.641v3.283l2.857-1.641zm-2.857 4.924-2.857-1.641v6.564l2.857-1.641z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BF3C",
    d: "M12.095.333.667 6.897 3.524 8.54l8.571-4.924 5.714 3.282 2.858-1.64zm0 9.847-2.857 1.64 2.857 1.641 2.857-1.64z"
  })));
};
export default SvgTensorFlowIcon;